import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@/store'
import { updatePreviewResponse } from '@/store/slices/preview'
import { Calendar } from '@/components/ui/calendar'
import { format } from 'date-fns'
import CalendarIcon from '@/assets/builder/icon/CalendarIcon'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@/components/ui/popover'

const Date: React.FC = () => {
    const dispatch = useDispatch()
    const { selectedQuestionId } = useSelector((state: any) => state.preview)
    // Get question data from Redux store
    const question = useSelector((state: RootState) =>
        state.preview.questions.find(
            (q: any) => q.questionId === selectedQuestionId
        )
    )

    const savedResponse = useSelector(
        (state: RootState) => state.preview.previewResponses[selectedQuestionId]
    )

    const [selectedDate, setSelectedDate] = useState<Date | undefined>(
        savedResponse?.value
    )

    // Update local state when Redux store changes
    useEffect(() => {
        if (savedResponse?.value) {
            setSelectedDate(savedResponse.value)
        } else {
            setSelectedDate(undefined)
        }
    }, [savedResponse])

    useEffect(() => {
        if (selectedDate) {
            dispatch(
                updatePreviewResponse({
                    questionId: selectedQuestionId,
                    response: {
                        value: selectedDate,
                    },
                })
            )
        }
    }, [selectedDate, dispatch, selectedQuestionId])

    if (!question) return null

    return (
        <div className="mt-6 w-full">
            <Popover>
                <PopoverTrigger className="w-full">
                    <Button
                        variant={'outline'}
                        className={cn(
                            'w-full h-[52px] justify-between text-left border-[#DEDEDE]',
                            !selectedDate && 'text-muted-foreground'
                        )}
                    >
                        {selectedDate ? (
                            format(selectedDate, 'yyyy-MM-dd')
                        ) : (
                            <span>YYYY-MM-DD</span>
                        )}
                        <CalendarIcon />
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-full p-0" align="end">
                    <Calendar
                        mode="single"
                        selected={selectedDate}
                        onSelect={setSelectedDate}
                        initialFocus
                    />
                </PopoverContent>
            </Popover>
        </div>
    )
}

export default Date
